export default __webpack_public_path__ + "static/media/arrow-right.b74efb02.svg";